const OfferStatus = `
  id
  description
  updatedAt
`;

export default OfferStatus;
